import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

// ======================
// QUERY
// ======================
export const PoolParticipantStatusQuerySchema = PaginationRequestSchema.extend({
  name: z.string().optional(),
});
export type PoolParticipantStatusQueryDTO = z.infer<typeof PoolParticipantStatusQuerySchema>;

// ======================
// RESPONSE
// ======================
export const PoolParticipantStatusResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  colorHex: z.string().nullable().optional(),
  canPredict: z.boolean(),
});
export type PoolParticipantStatusResponseDTO = z.infer<typeof PoolParticipantStatusResponseSchema>;

export const PoolParticipantStatusesPaginatedResponseSchema = PaginationResponseSchema(
  PoolParticipantStatusResponseSchema,
);
export type PoolParticipantStatusesPaginatedResponseDTO = z.infer<
  typeof PoolParticipantStatusesPaginatedResponseSchema
>;

// ======================
// CREATE
// ======================
export const CreatePoolParticipantStatusRequestSchema = z.object({
  id: z.string().min(1).max(50),
  name: z.string().min(1).max(100),
  description: z.string().nullable().optional(),
  colorHex: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, "Debe ser un color hex válido, ej: #10B981")
    .nullable()
    .optional(),
  canPredict: z.boolean().optional().default(false),
});
export type CreatePoolParticipantStatusRequestDTO = z.infer<
  typeof CreatePoolParticipantStatusRequestSchema
>;

// ======================
// UPDATE
// ======================
export const UpdatePoolParticipantStatusRequestSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  description: z.string().nullable().optional(),
  colorHex: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/, "Debe ser un color hex válido, ej: #10B981")
    .nullable()
    .optional(),
  canPredict: z.boolean().optional(),
});
export type UpdatePoolParticipantStatusRequestDTO = z.infer<
  typeof UpdatePoolParticipantStatusRequestSchema
>;
